<template>
	<TeamingChip
		:class-name="classNames"
		:text="text"
		@click="$emit( 'click', $event )"
	>
		<template v-slot:icon>
			<FontAwesomeIcon :icon="['far', 'calendar-check']" />
		</template>
	</TeamingChip>
</template>

<script>
import TeamingChip from "./TeamingChip";

export default {
	name: "DueChip",
	emits: [
		"click",
	],
	components: {
		TeamingChip,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			required: true,
		},
	},
	computed: {
		classes() {
			return {
				"due-chip": true,
				[ this.className ]: !!this.className,
			};
		},
		classNames() {
			return Object.keys( this.classes )
				.filter( className => !!this.classes[ className ] )
				.join( " " );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-chip.due-chip {
	background-color: $due-chip-background-color;
	display: inline-block;
	color: $due-chip-color;
}
</style>
